import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class CommonService {

	public userDetails: any;
	private loginRedirectUrl: any;
	public requestData: any;
	public viewData = new Subject();
	addressChange = new Subject();
	approverChange = new Subject();
	public searchChange = new Subject();
	public langChange = new Subject();

	constructor(private router: Router) {}

	changeSearchData(data:any) {
		this.searchChange.next(data);
	}

	changeLanguage(data:any) {
		this.langChange.next(data);
	}

	setData(data: any) {
		this.requestData = data;
	}

	getData() {
		return this.requestData;
	}

	changeViewData(data){
		this.viewData.next(data);
	}


	changeAddressData() {
		this.addressChange.next();
  	}
	
	changeApproverData(action) {
		this.approverChange.next(action);
  	}

	setUserDetails(userDetails) {
		this.userDetails = userDetails;
	}

	setLoginRedirectUrl(url) {
		this.loginRedirectUrl = url;
	}
	getLoginRedirectUrl() {
		return this.loginRedirectUrl;
	}
	
	contains(value, term, caseInsensitiveSearch) {
		if(!value) return false;
		if(!term) return false;
		if(caseInsensitiveSearch){
			value = value.toLowerCase();
			term = term.toLowerCase();
		}
		return (value.indexOf(term) != -1);
	}

	equals(value1, value2, caseInsensitiveMatch) {
		if(!value1) return false;
		if(!value2) return false;
		if(caseInsensitiveMatch){
			value1 = value1.toLowerCase();
			value2 = value2.toLowerCase();
		}
		return (value1==value2);
	}

	stopPropagationCheckBox(event) {
		if (event.stopPropagation) {
			event.stopPropagation();    // Standard
		}else {
			event.cancelBubble = true;  // Old IE
		}
	}

	getChoosenFile(event, componentModal, componentKey){
		let file = event.srcElement.files[0];
		let fileName  = file.name;
		var reader = new FileReader();
		reader.onload = function(){
			componentModal[componentKey] = {name:fileName,data:reader.result};
		}.bind(componentModal);
		reader.readAsDataURL(file);
	}

	navigateToLogin(){
		this.router.navigate(['/extra/login']);
	}
	
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/common.service.ts